import { render, staticRenderFns } from "./Ann.vue?vue&type=template&id=1b944a7e&"
import script from "./Ann.vue?vue&type=script&lang=js&"
export * from "./Ann.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports